import { useNavigate } from "react-router-dom";
import { calendarType } from "../../../../../../../../services/utils/CalendarType";
import { roles } from "../../../../../../../../services/utils/Roles";
import { useUserToken } from "../../../../../../../../hooks/core/UserToken";

const Event = ({ hour, events = [] }) => {
    const hourStr = hour.toString().padStart(2, "0") + ":00";
    const timeToMinutes = (time) => {
        const [hour, minutes] = time.split(":").map(Number);
        return hour * 60 + minutes;
    };
    const quarterTimes = ["00", "15", "30", "45"].map(
        (q) => `${hour.toString().padStart(2, "0")}:${q}`
    );
    const navigate = useNavigate();
    const [{ getDecoded }] = useUserToken();
    const decodedToken = getDecoded();

    const colorMap = {
        "#F89624": "calendar-event--color-1",
        "#F89953": "calendar-event--color-2",
        "#FEC33B": "calendar-event--color-3",
        "#FFD566": "calendar-event--color-4",
        "#6180C0": "calendar-event--color-5",
        "#09BBB5": "calendar-event--color-6",
        "#86D3E6": "calendar-event--color-7",
        "#BCD9F2": "calendar-event--color-8",
        "#8FC73E": "calendar-event--color-9",
        "#ADD25F": "calendar-event--color-10",
        "#F26B76": "calendar-event--color-11",
        "#F7A8B1": "calendar-event--color-12",
        "#F44336": "calendar-event--color-13",
    };

    return (
        <div className="calendar-daily-table__hour" data-hour={hourStr}>
            <div className="calendar-daily-table__main-time">
                <span>{hourStr}</span>
            </div>
            <div className="calendar-daily-table__quarters">
                {quarterTimes.map((qt, index) => {
                    const eventsAtThisQuarter = events.filter((event) => {
                        const eventStart = timeToMinutes(event.timeFrom);
                        const currentQuarter = timeToMinutes(qt);
                        const nextQuarter = currentQuarter + 15;
                    
                        return eventStart >= currentQuarter && eventStart < nextQuarter;
                    });

                    return (
                        <div key={index} className="calendar-daily-table__quarter" data-time={qt}>
                            {eventsAtThisQuarter.map((event, i) => {
                                const className = colorMap[event.color?.toUpperCase()] || "calendar-event--color-5";
                                return (
                                    <div
                                        key={i}
                                        className={`calendar-event-wrap ${event.isActive === false ? 'calendar-event-wrap--inactive' : ''}`}
                                        data-start={event.timeFrom}
                                        data-end={event.timeTo}
                                    >
                                        <div className={`calendar-event ${className}`}>
                                        <div className="calendar-event__time">
                                            <span
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    if (
                                                        (event.type === calendarType.MEETING || event.type === calendarType.STUDENT_TEST) &&
                                                        (decodedToken?.roles.includes(roles.SUPER_ADMIN) || event.createdBy === decodedToken.id)
                                                    ) {
                                                        navigate("/calendar/edit-event/" + event.id);
                                                    }
                                                }}
                                                style={{
                                                    cursor:
                                                        (event.type === calendarType.MEETING || event.type === calendarType.STUDENT_TEST) &&
                                                        (decodedToken?.roles.includes(roles.SUPER_ADMIN) || event.createdBy === decodedToken.id)
                                                            ? "pointer"
                                                            : "default"
                                                }} 
                                            >
                                                {event.timeFrom} – {event.timeTo}
                                            </span>
                                        </div>
                                            <div className="calendar-event__title">
                                                {event.title}
                                            </div>
                                            {event.description && (
                                                <div className="calendar-event__description">
                                                    {event.description}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Event;
